/* eslint-disable sonarjs/prefer-single-boolean-return */

type Props = {
  po: string | null
}

export const isProductOptionSubscription = ({ po }: Props) => {
  if (!po) return false

  return po === 'subscribe' || po === 'subscription'
}
